<template>
  <a :href="shareUrl" target="_blank" rel="noopener noreferrer">
    <slot>
      <BaseSocialShareButton>
        <SvgWhatsApp />
      </BaseSocialShareButton>
    </slot>
  </a>
</template>

<script setup lang="ts">
const props = defineProps<{
  shareText: string;
}>();

const shareUrl = computed(() => {
  const userAgent = useUserAgent();

  if (userAgent.mobileOs.value === "unknown") {
    return `https://web.whatsapp.com/send/?text=${props.shareText}`;
  } else {
    return `whatsapp://send?text=${props.shareText}`;
  }
});
</script>

<style lang="scss" scoped></style>
